import { Mail, Phone } from "lucide-react";

/** Straight-to-the-inbox contact block for people who aren't ready for the form. */
export const ContactBlock = ({ catering }) => {
  const email = catering?.contact_email;
  const phone = catering?.contact_phone;
  if (!email && !phone) return null;

  return (
    <div
      data-testid="events-contact"
      className="mt-14 border border-border bg-[#141414] p-7 md:p-10"
    >
      <h3 className="display text-2xl uppercase leading-none text-primary md:text-3xl">
        {catering.contact_title || "Rather just ask a question?"}
      </h3>
      {catering.contact_note ? (
        <p className="mt-4 max-w-2xl text-base text-muted-foreground">{catering.contact_note}</p>
      ) : null}
      <div className="mt-6 flex flex-wrap gap-4">
        {email ? (
          <a
            href={`mailto:${email}`}
            data-testid="events-contact-email"
            className="mono flex items-center gap-2 rounded-sm border border-primary px-5 py-3 text-[11px] tracking-widest text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
          >
            <Mail size={13} />
            {email.toUpperCase()}
          </a>
        ) : null}
        {phone ? (
          <a
            href={`tel:${phone.replace(/[^0-9+]/g, "")}`}
            data-testid="events-contact-phone"
            className="mono flex items-center gap-2 rounded-sm border border-border px-5 py-3 text-[11px] tracking-widest text-muted-foreground transition-colors hover:border-primary hover:text-primary"
          >
            <Phone size={13} />
            {phone}
          </a>
        ) : null}
      </div>
    </div>
  );
};
